import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <h1>Not Found</h1>
            <h3>404 error!!!!!!</h3>
        </div>
    );
};

export default NotFound;